import {
  CREATE_KONVERSI_POIN_SUCCESS,
  CREATE_KONVERSI_POIN_FAIL,
  RETRIEVE_KONVERSI_POIN_SUCCESS,
  RETRIEVE_KONVERSI_POIN_FAIL,
  UPDATE_KONVERSI_POIN_SUCCESS,
  UPDATE_KONVERSI_POIN_FAIL,
  DELETE_KONVERSI_POIN_SUCCESS,
  DELETE_KONVERSI_POIN_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_KONVERSI_POIN_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_KONVERSI_POIN_SUCCESS:
      return payload;

    case RETRIEVE_KONVERSI_POIN_FAIL:
      return [...datas];

    case UPDATE_KONVERSI_POIN_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_KONVERSI_POIN_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
